export default __webpack_public_path__ + "static/media/unassigned-task.edb82be2.svg";